import { BillingProvider } from "@/Common/Services/ExternalBilling/BillingProvider";
import { ExternalBillingClaimStatus } from "./ExternalBillingClaimStatus";

/**
 * The details of an external billing claim
 */
class ExternalBillingClaimDto {
    /**
     * The ID of the linked encounter.
     */
    public EncounterId: string;

    /**
     * The billing provider for which the claim was created.
     */
    public BillingProvider: BillingProvider;

    /**
     * The claim ID in the billing provider.
     */
    public ProviderClaimId: string;

    /**
     * The claim status.
     */
    public Status: ExternalBillingClaimStatus;

    /**
     * When the claimed services were administered.
     */
    public ClaimDate: Date;

    /**
     * The claimed service codes.
     */
    public Codes: string[];

    /**
     * The amount submitted for the claim; or null if the current user did not create the claim.
     */
    public AmountSubmitted?: number;

    /**
     * The amount paid for the claim; or null if the current user did not create the claim or the claim has not been processed.
     */
    public AmountPaid?: number;

    /**
     * Whether the claim can be cancelled.
     */
    public CanBeCancelled: boolean;

    /**
     * When the claim was created.
     */
    public DateCreated: Date;

    /**
     * The ID of the employee that created the claim.
     */
    public CreatedByEmployeeId: string;

    /**
     * The ID of the employee the claim was created for, if any.
     */
    public CreatedForEmployeeId?: string;

    /**
     * The display text for the claim.
     * Does not include payment amounts.
     */
    public DisplayText: string;

    /**
     * The service's diagnostic codes.
     */
    public DiagnosticCodes: string[];

    /**
     * Generate a new claim DTO with the given partial fields.
     * @param fields The partial fields used to create the DTO.
     */
    constructor(fields?: Partial<ExternalBillingClaimDto>) {
        Object.assign(this, fields);
    }
}

export { ExternalBillingClaimDto };
